import React, { useEffect, useState } from "react";
import SwitchMenuBar from "../../Components/SwitchMenuBar/SwitchMenuBar.js";
import "./CommonContainerStyles.css";
import Tabs from "../../Components/Tabs/Tabs";
import UserAvatar from "../../Components/UserAvatar/UserAvatarHome";
// import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import ViewBar from "../../Components/ViewBar/ViewBar.js";
import PopUp from "../../Components/PopUpForm/ShareProfile-PopUp";
import { getTeacherProfileName, getTeacherType } from "../../Helper";
import "./HomeContainer.css";
import "./HomeContainer2.css";
import ReactTooltip from "react-tooltip";
import { useLocation } from "react-router-dom";
import { ButtonGroup } from "react-bootstrap";
import { Row, Col } from 'react-bootstrap';
import { notify } from "react-notify-toast"
import LocalHospitalOutlinedIcon from '@mui/icons-material/LocalHospitalOutlined';
import { Box, Button } from "@mui/material";
import usiCheckImage from "../../assets/img/usi_check.jpg";
import payLevelImage from "../../assets/img/pay_level.png";
import ProgressBar from "../../Components/Stepper/ProgressBar.js";
import Auth from "../../Auth/Auth.js";
import { connect } from "react-redux";
import { updatePersonalDetails } from "../../redux/homePage/homePage.actions.js";

export let displayPoliceCheckWwCC;
function HomeContainer(props) {
  const {
    // tabs,
    tabProfileActive,
    tabDashboardActive,
    tabResumeActive,
    tabVetResumeActive,
    isShared,
    user,
    uploadAvatar,
    isShowUploadAvatar,
    isViewAsTeacher,
    isShowPoliceCheckWwcc,
    history,
    hideViewBar,
    isViewAsCollege,
    tabEcecResumeActive
  } = props;
  const role = Auth.verifyUserRole();
  const showProgressBar = user?.is_show_progress_bar != undefined ? user.is_show_progress_bar : true
  const [formType, setFormType] = useState("");
  const [isPopup, togglePopup] = useState(false);
  const [isShowProgressBar, setIsShowProgressBar] = useState(showProgressBar)

  useEffect(() => {
    if (window.location.hash === '#focusPhoto') {
      notify.show('Please click on the camera icon inside the Profile photo placeholder to upload your photo')
    }},[]);

  let location = useLocation();

  function handlePoliceCheck() {
    if (isViewAsTeacher) {
      history.push("/policeCheck");
    } else {
      if (user.police_check_url) {
        // window.open(user.police_check_url, "_blank");
        window.open(
          `/NavigateToFileViewer?fileurl=${user.police_check_url}`,
          "_blank"
        );
        // return (
        //   <Link
        //     to={{
        //       // pathname: `https://n35tl2czql.execute-api.ap-southeast-2.amazonaws.com/default/getfile?url=${user.police_check_url}`,
        //       pathname: user.police_check_url,
        //     }}
        //     target="_blank"
        //   >
        //     {" "}
        //   </Link>
        // );
      }
    }
  }

  function handleWwcc() {
    if (isViewAsTeacher) {
      history.push("/wwcc");
    } else {
      if (user.wwcc_url) {
        // const path = {
        //   pathname: "/fileviewer",
        //   fileurl: "https://platform-backend-files.s3-ap-southeast-2.amazonaws.com/5e5e39b53d01b5528aeddfb1/qualification/transcriptUSC%20Transcripts_wm.pdf?v=1",
        // }
        // history.push(path)
        // const param = 'https://platform-backend-files.s3-ap-southeast-2.amazonaws.com/5e5e39b53d01b5528aeddfb1/qualification/transcriptUSC%20Transcripts_wm.pdf?v=1'
        window.open(`/NavigateToFileViewer?fileurl=${user.wwcc_url}`, "_blank");
        // window.open(user.wwcc_url, "_blank");
        // return (
        //   <Link
        //     to={{
        //       pathname: `https://n35tl2czql.execute-api.ap-southeast-2.amazonaws.com/default/getfile?url=${user.wwcc_url}`,
        //     }}
        //     target="_blank"
        //   ></Link>
        // );
      }
    }
  }

  function handleEcec() {
    if (isViewAsTeacher) {
      history.push("/ececcheck");
    } else {
      if (user?.ecec_url) {
        window.open(`/NavigateToFileViewer?fileurl=${user.ecec_url}`, "_blank");
      }
    }
  }

  function handleUsiCheck() {
    if (isViewAsTeacher) {
      history.push("/usiCheck");
    } else {
      if (user.usi_url) {
        window.open(`/NavigateToFileViewer?fileurl=${user.usi_url}`, "_blank");
      }
    }
  }

  function handleUploadPayLevel() {
    if (isViewAsTeacher) {
      history.push("/uploadPayLevel");
    } else {
      if (user.usi_url) {
        window.open(`/NavigateToFileViewer?fileurl=${user?.pay_level?.url}`, "_blank");
      }
    }
  }

  let wwccMes;
  let policeCheckMes;
  let ececCheckMes = "";
  let usiCheckMes;
  let payLevelMes = "";

  if (isViewAsTeacher) {
    wwccMes = "Add/Edit WWCC";
    policeCheckMes = "Add/Edit Police Check";
    usiCheckMes = "Add/Edit USI Check";
    ececCheckMes = user?.is_childhood_teacher ? "Add/Edit First AID" : ""
    payLevelMes = "Add/Edit Pay Level evidence";
  } else {
    wwccMes = user.wwcc_url ? "View WWCC" : "WWCC unavailable";
    policeCheckMes = user.police_check_url
      ? "View Police Check"
      : "Police check unavailable";
    ececCheckMes = user?.ecec_url ? "View First AID" : "First AID unavailable"
    usiCheckMes = user.usi_url
      ? "View Usi Check"
      : "Usi check unavailable";
    payLevelMes = user?.pay_level?.status ? "View Pay Level evidence" : "Pay Level evidence unavailable"
  }

  if (isShowPoliceCheckWwcc) {
    displayPoliceCheckWwCC = (
      <div>
        <div className="police-usiCheck-wwcc-inner-wrapper">
          {/*<div className="mdi mdi-face wwcc-icon" onClick={handleWwcc} > </div> */}
          {!user.wwcc_url ? (
            <div>
              <div
                className={
                isViewAsTeacher
                  ? "mdi mdi-face wwcc-icon"
                  : "mdi mdi-face wwcc-icon-no-hover"
                }
                onClick={handleWwcc}
                data-tip={wwccMes}
                data-for="wwcc-hover"
              />
              <ReactTooltip
                backgroundColor="rgb(47, 224, 222)"
                id="wwcc-hover"
                effect="solid"
              />
            </div>
          ) : (
            <div className="wwcc-box-uploaded">
              <div
                className="mdi mdi-face wwcc-icon-uploaded"
                onClick={handleWwcc}
                data-tip={wwccMes}
                data-for="wwcc-hover"
              >
                {" "}
              </div>
              <ReactTooltip
                backgroundColor="rgb(47, 224, 222)"
                id="wwcc-hover"
                effect="solid"
              />
            </div>
          )}

          {!user.police_check_url ? (
            <div className="policeCheck-box">
              <div
                className={
                  isViewAsTeacher
                    ? "mdi mdi-fingerprint police-check-icon"
                    : "mdi mdi-fingerprint police-check-icon-no-hover"
                }
                onClick={handlePoliceCheck}
                data-tip={policeCheckMes}
                data-for="police-check-hover"
              >
                {" "}
              </div>
              <ReactTooltip
                backgroundColor="rgb(47, 224, 222)"
                id="police-check-hover"
                effect="solid"
              />
            </div>
          ) : (
            <div className="policeCheck-box">
              <div
                className="mdi mdi-fingerprint police-check-icon-uploaded"
                onClick={handlePoliceCheck}
                data-tip={policeCheckMes}
                data-for="police-check-hover"
              >
                {" "}
              </div>
              <ReactTooltip
                backgroundColor="rgb(47, 224, 222)"
                id="police-check-hover"
                effect="solid"
              />
            </div>
          )}

          {user?.is_childhood_teacher && !user.ecec_url && (
            <div className="ececCheck-box">
              <Box
                sx={{
                  fontSize: "75px",
                  marginLeft: "30px",
                  '&:hover': { cursor: 'pointer' }
                }}
                className="ecec-un-upload"
                onClick={handleEcec}
                data-tip={ececCheckMes}
                data-for="ecec-check-hover"
              >
                <LocalHospitalOutlinedIcon sx={{fontSize: "91px"}} />
              </Box>
              <ReactTooltip
                backgroundColor="rgb(47, 224, 222)"
                id="ecec-check-hover"
                effect="solid"
              />
            </div>
          )}
          {
            user?.is_childhood_teacher && user.ecec_url && (
              <div className="ececCheck-box">
                <Box
                  sx={{
                    fontSize: "75px",
                    marginLeft: "30px",
                    '&:hover': { cursor: 'pointer' }
                  }}
                  className="ecec-uploaded"
                  onClick={handleEcec}
                  data-tip={ececCheckMes}
                  data-for="ecec-check-hover"
                >
                  <LocalHospitalOutlinedIcon sx={{fontSize: "91px"}}/>
                </Box>
                <ReactTooltip
                  backgroundColor="rgb(47, 224, 222)"
                  id="ecec-check-hover"
                  effect="solid"
                />
              </div>
            )
          }

          {!user.usi_url
            ? (
              <div className="usiCheck-box">
                <div
                  className={
                    isViewAsTeacher
                      ? "usi-check-img"
                      : "usi-check-img-no-hover"
                  }
                  onClick={handleUsiCheck}
                  data-tip={usiCheckMes}
                  data-for="usi-check-hover"
                >
                  <img src={usiCheckImage} alt="usi check"/>
                </div>
                <ReactTooltip
                  backgroundColor="rgb(47, 224, 222)"
                  id="usi-check-hover"
                  effect="solid"
                />
              </div>
              )
            : (
              <div className="usiCheck-box">
                <div
                  className="usi-check-img-uploaded"
                  onClick={handleUsiCheck}
                  data-tip={usiCheckMes}
                  data-for="usi-check-hover"
                >
                  <img src={usiCheckImage} alt="usi check"/>
                </div>
                <ReactTooltip
                  backgroundColor="rgb(47, 224, 222)"
                  id="usi-check-hover"
                  effect="solid"
                />
              </div>
            )
          }

          {
            user?.is_elt && isViewAsTeacher && (
              <>
              {
                !user?.pay_level?.status || user?.pay_level?.status === "rejected"
                ? (
                  <div className="pay-level-box">
                    <div
                      className="un-upload"
                      onClick={handleUploadPayLevel}
                      data-tip={payLevelMes}
                      data-for="pay-level-hover"
                    >
                      <img src={payLevelImage} alt="Pay Level"/>
                    </div>
                    <ReactTooltip
                      backgroundColor="rgb(47, 224, 222)"
                      id="pay-level-hover"
                      effect="solid"
                    />
                  </div>
                  )
                : (
                  <div className="pay-level-box">
                    <div
                      onClick={handleUploadPayLevel}
                      data-tip={payLevelMes}
                      data-for="pay-level-hover"
                    >
                      <img src={payLevelImage} alt="Pay Level"/>
                    </div>
                    <ReactTooltip
                      backgroundColor="rgb(47, 224, 222)"
                      id="pay-level-hover"
                      effect="solid"
                    />
                  </div>
                )
              }
              </>
            )
          }

          {/*<div className="mdi mdi-fingerprint police-check-icon" onClick={handlePoliceCheck}> </div> */}
        </div>
      </div>
    );
  } else {
    displayPoliceCheckWwCC = null;
  }

  let tabs;
  const isResumeActive = !tabProfileActive && !tabDashboardActive;
  const addNewTab = (path, text, isActive, className, dataObj = null) => {
    tabs.push({
      pathname: path,
      data: dataObj,
      text: text,
      active: isActive,
      className: className,
    });
  };

  if (isShared) {
    tabs = [
      {
        pathname: `/NavigateToShareProfile?id=${user._id}`,
        text: "Profile",
        active: tabProfileActive && !tabResumeActive && !tabDashboardActive,
        newWindow: true,
      },
    ];

    if (user.is_elt === true && user.is_vet === true) {
      addNewTab(
        "/SharedResume",
        "ELT Resume",
        isResumeActive && tabResumeActive,
        null,
        user
      );
      addNewTab(
        "/SharedVetResume",
        "VET Resume",
        isResumeActive && tabVetResumeActive,
        null,
        user
      );
    } else if (user.is_elt === true) {
      addNewTab(
        "/SharedResume",
        "Resume",
        isResumeActive && tabResumeActive,
        null,
        user
      );
    } else if (user.is_vet === true) {
      addNewTab(
        "/SharedVetResume",
        "Resume",
        isResumeActive && tabVetResumeActive,
        null,
        user
      );
    } else if (user?.is_childhood_teacher) {
      addNewTab(
        "/SharedEcecResume",
        "Resume",
        isResumeActive && tabEcecResumeActive,
        null,
        user
      );
    }
  } else if (isViewAsTeacher) {
    tabs = [
      {
        pathname: "/Dashboard",
        text: "Dashboard",
        active: tabDashboardActive,
      },
      {
        pathname: "/",
        text: "Profile",
        active: tabProfileActive,
        className: "dash-tour-profile",
      },
    ];

    if (user.is_elt === true && user.is_vet === true) {
      addNewTab("/resume", "ELT Resume", tabResumeActive, "dash-tour-resume");
      addNewTab("/VocationalResume", "VET Resume", tabVetResumeActive);
    } else if (user.is_elt === true) {
      addNewTab("/resume", "Resume", tabResumeActive, "dash-tour-resume");
    } else if (user.is_vet === true) {
      addNewTab(
        "/VocationalResume",
        "Resume",
        tabVetResumeActive,
        "dash-tour-resume"
      );
    }
    if (user.is_childhood_teacher) {
      addNewTab(
        "/ececResume",
        "Resume",
        tabEcecResumeActive,
        "dash-tour-resume"
      )
    }
  } else {
    tabs = [
      {
        pathname: "/previewProfile",
        text: "Profile",
        active: tabProfileActive && !tabResumeActive && !tabDashboardActive,
      },
    ];

    if (user.is_elt === true && user.is_vet === true) {
      addNewTab(
        "/previewResume",
        "ELT Resume",
        isResumeActive && tabResumeActive && !tabDashboardActive
      );
      addNewTab(
        "/PreviewVetResume",
        "VET Resume",
        isResumeActive && tabVetResumeActive && !tabDashboardActive
      );
    } else if (user.is_elt === true) {
      addNewTab("/previewResume", "Resume", isResumeActive && tabResumeActive);
    } else if (user.is_vet === true) {
      addNewTab(
        "/PreviewVetResume",
        "Resume",
        isResumeActive && tabVetResumeActive
      );
    }  else if (user?.is_childhood_teacher) {
      addNewTab(
        "/PreviewEcecResume",
        "Resume",
        isResumeActive && tabEcecResumeActive
      );
    }
  }

  const showShareProfile = () => {
    // console.log("run function share");

    setFormType("shareProfile");
    togglePopup(true);
  };

  const bookTeacher = () => {
    props.history.push("/CollegeCalendar", {
      teacher_name: {
        first_name: user.first_name,
        last_name: user.last_name,
        preferred_name: user.preferred_name
      },
      teacher_avatar: user.img_url,
      teacher_id: user._id,
      show_modal: true
    })
  }

  const handleToggleProgressBar = () => {
    props.updatePersonalDetails({
      is_show_progress_bar: !isShowProgressBar
    })
    setIsShowProgressBar(!isShowProgressBar)
  }

  // console.log("Is the resume active",isResumeActive);
  return (
    <div className="page-container-outer">
      <div className="menu-logo-bar">
        {!isShared && !hideViewBar && (
          <ViewBar
            user={user}
            isViewAsTeacher={isViewAsTeacher}
            tabProfileActive={tabProfileActive}
            tabVetResumeActive={tabVetResumeActive}
          />
        )}
        <SwitchMenuBar
          isViewAsTeacher={isViewAsTeacher}
          isViewAsCollege={isViewAsCollege}
        />
      </div>
      <div className="page-container-main bg-photoregister">
        <div className="bg-gradient page-container-bg"></div>
        <div className="page-container-header">
          {/* header contents like teacher avatar, name/location, share button will go in here  */}
          <div className="page-container-header-inner">
            <div className="home-container-teacher-info">
            {/* displayPoliceCheckWwCC */}
              <UserAvatar icon={user.img_url} page="home">
                {isShowUploadAvatar ? (
                  <span
                    className="mdi mdi-camera home-upload-avatar-button"
                    onClick={uploadAvatar}
                  ></span>
                ) : null}
              </UserAvatar>
              <div className="home-teacher-name">
                    <div className="teachername">{getTeacherProfileName(user)}</div>
                    <div className="h-secondary">{getTeacherType(user)}</div>
                    {
                      !user?.is_childhood_teacher
                      ? (
                        <div>
                        <div className="h-secondary-location">
                          <i className="mdi mdi-map-marker"></i>
                          <strong>{"LIVES "}</strong>{[user.city ? user.city : null, user.state].filter(Boolean).join(", ")}
                        </div>
                        <div className="h-secondary-location">
                          <i className="mdi mdi-earth"></i>
                          <strong>{"OPEN TO WORK "}</strong>{[user.preferred_online ? "Online" : null, user.preferred_city1, user.preferred_city2, user.preferred_city3].filter(Boolean).join(", ")}
                        </div>
                        </div>
                      ) : (
                        <div>
                        <div className="h-secondary-location">
                          <i className="mdi mdi-map-marker"></i>
                          <strong>{"LIVES "}</strong>{[user.city ? user.city : null, user.state].filter(Boolean).join(", ")}
                        </div>
                        <div className="h-secondary-location">
                          <i className="mdi mdi-map-marker">
                          <strong>{"OPEN TO WORK "}</strong>
                            {
                              [user.preferred_city1, user.preferred_city2, user.preferred_city3]
                                .filter(Boolean)
                                .join(", ")
                            }
                          </i>{" "}
                        </div>
                        </div>
                      )
                    }
              </div>
            </div>
            <div className="home-container-buttons mb-10">
                    <ButtonGroup size="lg" aria-label="button group">
                      {!isViewAsTeacher ?
                        <button
                          type='button'
                          className='btn btn-primary'
                          onClick={bookTeacher}>
                            Book Me
                        </button>
                        : <></>
                      }
                      <button
                        className="btn btn-primary"
                        onClick={showShareProfile} >
                        <a
                          className="mdi mdi-share bold"
                          data-tip="Share Profile"
                          data-for="share-profile">
                        </a>
                        <ReactTooltip
                          place="right"
                          backgroundColor="rgb(47, 224, 222)"
                          effect="solid"
                          id="share-profile"
                        />
                      </button>
                    </ButtonGroup>
            {/* {displayWhereby} */}
          </div>
          </div>
        </div>

        {
          (role === "admin" || isViewAsTeacher) && (
            <>
              {
                !isShowProgressBar && (
                  <div>
                    <Box className="d-flex justify-content-end mb-2">
                      <Button
                        className={"hide-progress-bar show-progress-bar"}
                        sx={{ borderRadius: "25px", color: "white", border: "1px solid white", '&:hover': { borderColor: "white"} }}
                        variant="outlined"
                        color="success"
                        onClick={handleToggleProgressBar}
                      >
                        Show Progress Bar
                      </Button>
                    </Box>
                    <div className="mb-5"></div>
                  </div>
                )
              }
              {
                isShowProgressBar && (
                  <Box className="page-container-process-bar"
                    sx={{
                      height: "200px",
                      background: "#84bec7",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "50px",
                      position: "relative",
                    }}
                  >
                    <Box className="position-absolute" sx={{top: "5px", right: "5px"}}>
                      <Box className="d-flex justify-content-end mb-2">
                        <Button
                          className={"hide-progress-bar show-progress-bar"}
                          sx={{ borderRadius: "25px", color: "white", border: "1px solid white", '&:hover': { borderColor: "white"} }}
                          variant="outlined"
                          color="success"
                          onClick={handleToggleProgressBar}
                        >
                          Hide Progress Bar
                        </Button>
                      </Box>
                    </Box>
                    <ProgressBar
                      user={user}
                      tabResumeActive={tabResumeActive}
                      tabVetResumeActive={tabVetResumeActive}
                      tabEcecResumeActive={tabEcecResumeActive}
                    />
                  </Box>
                )
              }
            </>
          )
        }

        <div className="page-container-inner">
          {tabs ? <Tabs tabs={tabs} /> : null}
          {isResumeActive && !tabVetResumeActive && !tabResumeActive && !user?.is_childhood_teacher ? (
            <div className="home-container-spacing-resume">
              {props.children}
            </div>
          ) : (
            <div>{props.children}</div>
          )}
        </div>
      </div>
      {/* <StickyButton/> */}
      {isPopup && (
        <PopUp
          user={user}
          showPopup={togglePopup}
          formType={formType}
          isShared={isShared}
        />
      )}
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  updatePersonalDetails: (details) => dispatch(updatePersonalDetails(details)),
});

export default connect(
  null,
  mapDispatchToProps
)(withRouter(HomeContainer));